import ReservationDetailsOwnerPage from "containers/Client/Reservation/reservationDetailsOwnerPage";
import { AuthContext } from "context/appContext";
import { useAppDispatch, useAppSelector, useScrollToTop } from "hooks/hooks";
import useIsMobile from "hooks/isMobile";
import { FC, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { confirmReservation, fetchPendingOwnerReservation } from "redux/features/reservations/reservationSlice";
import Badge from "shared/Badge/Badge";
import Pagination from "shared/Pagination/Pagination";
import { socket } from "../../utils/socket";
import AlertModalDelete from "./AlertModalDelete";

export interface SectionGridFilterCardOwnerProps {
  className?: string;
}
interface ReservationLoadingState {
  [key: string]: boolean;
}
const SectionGridFilterCardOwner: FC<SectionGridFilterCardOwnerProps> = ({ className = "" }) => {
  const authContext = useContext(AuthContext);
  const profilId = authContext?.user?.profil?.id;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoadingApprove, setIsLoadingApprove] = useState<ReservationLoadingState>({});
  const [isLoadingReject, setIsLoadingReject] = useState<ReservationLoadingState>({});
  const [hide, setHide] = useState<ReservationLoadingState>({});
  const [currentPage, setCurrentPage] = useState(1);
  const reservationState: any = useAppSelector((state) => state.featureReservation.reservations);
  const totalPages = useAppSelector((state) => state.featureReservation.totalPages);
  const totalCount = useAppSelector((state) => state.featureReservation.totalCount);

  console.log("reservationState", reservationState);

  useScrollToTop();
  useEffect(() => {
    if (profilId) {
      dispatch(fetchPendingOwnerReservation({ id: profilId, page: currentPage }));
    }
  }, [profilId, currentPage]);
  const [showReservationDetails, setShowReservationDetails] = useState(false);
  const [selectedReservation, setselectedReservation] = useState(null);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };
  const handleEyeIconClick = (reservation: any) => {
    setselectedReservation(reservation);
    setShowReservationDetails(!showReservationDetails);
  };
  const handleClick = async (reservation: any, response: any) => {
    if (setShowModal) {
      setShowModal(false);
    }
    if (setShowDeleteModal) {
      setShowDeleteModal(false);
    }
    if (response === true) {
      setIsLoadingApprove((prevState) => ({
        ...prevState,
        [reservation.id]: true,
      }));
    } else {
      setIsLoadingReject((prevState) => ({
        ...prevState,
        [reservation.id]: true,
      }));
    }
    const approuve = { approuved: response };
    const res = await dispatch(confirmReservation({ data: approuve, id: reservation.id }));
    const reservationDetail = reservationState[0];
    const senderId = reservationDetail?.Owner?.userId;
    const receiverId = reservationDetail?.Client?.userId;

    if (res.payload?.sendNotification !== undefined) {
      const action = res.payload.sendNotification ? "confirm_reservation" : "negate_reservation";

      socket.emit("send-notification", {
        senderId,
        receiverId,
        action,
        reservationId: reservation?.id,
        reservation,
      });
    }
    if (approuve.approuved === true) {
      navigate("/client/mes-reservations");
    }
    dispatch(fetchPendingOwnerReservation({ id: profilId, page: currentPage }));
    setHide((prevState) => ({
      ...prevState,
      [reservation.id]: true,
    }));
    if (response === true) {
      setIsLoadingApprove((prevState) => ({
        ...prevState,
        [reservation.id]: false,
      }));
    } else {
      setIsLoadingReject((prevState) => ({
        ...prevState,
        [reservation.id]: false,
      }));
    }
  };
  const isReservationOngoing = (item: any) => {
    const currentDate = new Date();
    const createdAtDate = new Date(item.createdAt);
    const twoDaysAfterCreatedAt = new Date(createdAtDate);
    twoDaysAfterCreatedAt.setDate(createdAtDate.getDate() + 2);
    return currentDate.getTime() >= twoDaysAfterCreatedAt.getTime();
  };

  const [showModal, setShowModal] = useState(false);
  const handleOpen = async (reservation: any) => {
    setselectedReservation(reservation);
    if (setShowModal) {
      setShowModal(true);
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleOpenDelete = async (reservation: any) => {
    setselectedReservation(reservation);
    if (setShowDeleteModal) {
      setShowDeleteModal(true);
    }
  };
  const isMobile = useIsMobile();

  return (
    <>
      <div className={`w-full rounded-md ${className}`}>
        <div className="flex items-center justify-between pb-1">
          <div>
            <h2 className="font-semibold text-gray-600 dark:text-white">Mes demande de réservation</h2>
          </div>
        </div>

        {isMobile ? (
          <>
            {" "}
            {reservationState.map((item: any) => (
              <div className="flex justify-center mt-2">
                <div className="w-full max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex justify-end px-4 pt-4">
                    <Badge
                      className="hover:bg-black hover:text-white"
                      name={
                        <FaEye className="w-4 h-4 cursor-pointer" onClick={() => handleEyeIconClick(item)}></FaEye>
                      }
                    ></Badge>
                  </div>
                  <div className="flex flex-col items-center pb-10">
                    <img
                      className="w-24 h-24 mb-3 rounded-full shadow-lg"
                      src={`${process.env.REACT_APP_CLOUD_FRONT + item?.Location?.images[0]}`}
                      alt={item?.Location?.title}
                    ></img>
                    <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">{item.reference}</h5>
                    <div className="flex mt-4 md:mt-6">
                      {item?.approuved == null && hide && !isReservationOngoing(item) && (
                        <div className="flex space-x-4">
                          {/* Confirm Button */}

                          {item?.isEventPassed === true ? (
                            <div className="relative inline-block group">
                              <button
                                className="cursor-not-allowed text-neutral-300 hover:text-green-700"
                                disabled
                              >
                                {isLoadingApprove[item.id] ? (
                                  <i className="text-xl las la-spinner animate-spin"></i>
                                ) : (
                                  <i className="text-xl las la-check-circle"></i>
                                )}
                                <span className="sr-only">Confirm</span>
                              </button>

                              {/* Tooltip */}
                              <div className="relative ml-2 group">
                                <span className="absolute hidden px-2 py-1 mb-2 text-xs text-white -translate-x-1/2 rounded left-1/2 bottom-full group-hover:block bg-neutral-800 dark:bg-neutral-700 whitespace-nowrap">
                                  Trop tard pour accepter cette réservation.
                                  <br />
                                  L’événement concerné est déjà passé.
                                  <br />
                                  Il n’est plus possible d’accepter cette demande.
                                </span>
                              </div>
                            </div>
                          ) : (
                            <button
                              className="text-green-500 hover:text-green-700"
                              onClick={() => handleOpen(item)}
                              disabled={isLoadingApprove[item.id]}
                            >
                              {isLoadingApprove[item.id] ? (
                                <i className="text-xl las la-spinner animate-spin"></i>
                              ) : (
                                <i className="text-xl las la-check-circle"></i>
                              )}
                              <span className="sr-only">Confirm</span>
                            </button>
                          )}

                          {/* Delete Button */}
                          <button
                            className="text-red-500 hover:text-red-700"
                            onClick={() => handleOpenDelete(item)}
                            disabled={isLoadingReject[item.id]}
                          >
                            {isLoadingReject[item.id] ? (
                              <i className="text-xl las la-spinner animate-spin"></i>
                            ) : (
                              <i className="text-xl las la-times-circle"></i>
                            )}
                            <span className="sr-only">Delete</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
              <table className="min-w-full leading-normal">
                <thead>
                  <tr className="justify-center">
                    <th className="px-5 py-5 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase border-b-2 dark:bg-gray-800 dark:text-white">
                      Images
                    </th>
                    <th className="text-xs font-semibold tracking-wider text-left text-gray-600 uppercase border-b-2 dark:bg-gray-800 dark:text-white">
                      Code
                    </th>
                    <th className="text-xs font-semibold tracking-wider text-left text-gray-600 uppercase border-b-2 dark:bg-gray-800 dark:text-white">
                      Status
                    </th>
                    <th className="text-xs font-semibold tracking-wider text-left text-gray-600 uppercase border-b-2 dark:bg-gray-800 dark:text-white">
                      Consulter
                    </th>
                    <th className="py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase border-b-2 dark:bg-gray-800 dark:text-white">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reservationState.map((reservation: any) => (
                    <tr key={reservation.id}>
                      <td className="px-5 py-5 text-sm dark:bg-gray-800">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 w-10 h-10">
                            <img
                              className="w-full h-full rounded-full"
                              src={`${process.env.REACT_APP_CLOUD_FRONT + reservation?.Location?.images[0]}`}
                              alt=""
                            />
                          </div>
                        </div>
                      </td>
                      <td className="text-sm dark:bg-gray-800">
                        <p className="text-gray-900 whitespace-no-wrap dark:text-white">
                          {reservation?.reference}
                        </p>
                      </td>
                      <td className="text-sm dark:bg-gray-800">En attente</td>
                      <td className="px-5 text-sm dark:bg-gray-800">
                        <i
                          className="text-2xl cursor-pointer las la-eye"
                          onClick={() => handleEyeIconClick(reservation)}
                        ></i>
                      </td>

                      {/* Action Column */}
                      <td className="text-sm dark:bg-gray-800">
                        {reservation?.approuved == null && hide && !isReservationOngoing(reservation) && (
                          <div className="flex space-x-4">
                            {/* Confirm Button */}
                            {reservation?.isEventPassed === true ? (
                              <div className="relative inline-block group">
                                <button
                                  className="cursor-not-allowed text-neutral-300 hover:text-green-700"
                                  disabled
                                >
                                  {isLoadingApprove[reservation.id] ? (
                                    <i className="text-xl las la-spinner animate-spin"></i>
                                  ) : (
                                    <i className="text-xl las la-check-circle"></i>
                                  )}
                                  <span className="sr-only">Confirm</span>
                                </button>

                                {/* Tooltip */}
                                <div className="relative ml-2 group">
                                  <span className="absolute hidden px-2 py-1 mb-2 text-xs text-white -translate-x-1/2 rounded left-1/2 bottom-full group-hover:block bg-neutral-800 dark:bg-neutral-700 whitespace-nowrap">
                                    Trop tard pour accepter cette réservation.
                                    <br />
                                    L’événement concerné est déjà passé.
                                    <br />
                                    Il n’est plus possible d’accepter cette demande.
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <button
                                className="text-green-500 hover:text-green-700"
                                onClick={() => handleOpen(reservation)}
                                disabled={isLoadingApprove[reservation.id]}
                              >
                                {isLoadingApprove[reservation.id] ? (
                                  <i className="text-xl las la-spinner animate-spin"></i>
                                ) : (
                                  <i className="text-xl las la-check-circle"></i>
                                )}
                                <span className="sr-only">Confirm</span>
                              </button>
                            )}

                            {/* Delete Button */}
                            <button
                              className="text-red-500 hover:text-red-700"
                              onClick={() => handleOpenDelete(reservation)}
                              disabled={isLoadingReject[reservation.id]}
                            >
                              {isLoadingReject[reservation.id] ? (
                                <i className="text-xl las la-spinner animate-spin"></i>
                              ) : (
                                <i className="text-xl las la-times-circle"></i>
                              )}
                              <span className="sr-only">Delete</span>
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div>
          <AlertModalDelete
            open={showModal}
            handleDelete={() => handleClick(selectedReservation, true)}
            handleClose={() => setShowModal(false)}
            message={`Êtes-vous sûr(e) de vouloir accepter cette réservation ?`}
            alertText="Acceptation de réservation"
          />
          <AlertModalDelete
            open={showDeleteModal}
            handleDelete={() => handleClick(selectedReservation, false)}
            handleClose={() => setShowDeleteModal(false)}
            message={`Êtes-vous sûr(e) de vouloir refuser cette réservation ?`}
            alertText="Refus de réservation"
          />
          {showReservationDetails && (
            <ReservationDetailsOwnerPage
              open={true}
              handleClose={() => setShowReservationDetails(false)}
              Data={selectedReservation}
            />
          )}

          <div className="flex items-center justify-center ">
            {totalPages > 1 && (
              <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            )}
          </div>
        </div>
        {totalPages === 0 && (
          <div className="flex items-center justify-center mt-16">
            <p>Aucune demande de réservation disponible pour le moment.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default SectionGridFilterCardOwner;
